class ProductNotifyForm extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.onSectionChange = this.onSectionChange.bind(this);
  }

  connectedCallback() {
    this.messageEl = this.querySelector('.product-notify-form__message');
    this.formEl = this.querySelector('.product-notify-form__form');
    this.inputsEl = this.querySelector('.product-notify-form__inputs');

    this.strings = {
      email: window.notifyFormStrings?.email || 'Enter your email address...',
      send: window.notifyFormStrings?.send || 'Send',
      messageFirst: window.notifyFormStrings?.messageFirst || 'Please notify me when ',
      messageLast: window.notifyFormStrings?.messageLast || ' becomes available - ',
      success: window.notifyFormStrings?.success || 'Thanks! We will notify you when this product becomes available!',
    };

    this.baseUrl = this.inputsEl?.dataset.url || this.dataset.productUrl;

    this.handleSuccessRedirect();
    this.subscribeToVariantChanges();
    this.initCurrentVariant();
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    if (this.sectionChangeUnsubscriber) this.sectionChangeUnsubscriber();
  }

  getSection() {
    return document.querySelector(`#shopify-section-${this.dataset.sectionId}`);
  }

  subscribeToVariantChanges() {
    const sectionId = this.dataset.sectionId;

    // Dawn PubSub (most versions)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data || event;
        if (data?.sectionId === sectionId) {
          this.onVariantChange(data.variant);
        }
      });
    }

    // Dawn section re-render after variant change
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.sectionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {});
    }

    const section = this.getSection();
    if (!section) return;

    // Fallback: listen to variant picker changes directly
    section.addEventListener('change', (event) => {
      const target = event.target;
      if (
        target.matches('input[name="id"]') ||
        target.closest('variant-selects') ||
        target.closest('variant-radios')
      ) {
        setTimeout(() => this.initCurrentVariant(), 0);
      }
    });
  }

  initCurrentVariant() {
    const section = this.getSection();
    if (!section) return;

    // Dawn stores selected variant JSON here
    const variantJsonEl =
      section.querySelector('[data-selected-variant]') ||
      section.querySelector('variant-selects [type="application/json"]') ||
      section.querySelector('variant-radios [type="application/json"]');

    if (variantJsonEl && variantJsonEl.textContent) {
      try {
        const variant = JSON.parse(variantJsonEl.textContent);
        this.onVariantChange(variant);
        return;
      } catch (e) {}
    }

    // Fallback: read variant id from form and match product JSON
    const productJsonEl = section.querySelector('[id^="ProductJSON-"]');
    const idInput = section.querySelector('input[name="id"]:checked, select[name="id"], input[name="id"]');

    if (productJsonEl && idInput) {
      try {
        const product = JSON.parse(productJsonEl.textContent);
        const variantId = Number(idInput.value);
        const variant = product.variants.find((v) => v.id === variantId);
        if (variant) this.onVariantChange(variant);
      } catch (e) {}
    }
  }

  onVariantChange(variant) {
    if (!this.inputsEl) return;

    if (variant && variant.available === false) {
      this.hidden = false;
      this.renderInputs(variant);
    } else {
      this.hidden = true;
      this.clearInputs();
    }
  }

renderInputs(variant) {
  const variantTitle = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
  const message =
    this.strings.messageFirst +
    (this.dataset.productTitle || '') +
    this.strings.messageLast +
    this.baseUrl;

  const customerEmail = this.dataset.customerEmail;
  const emailId = `notify-email-${this.dataset.sectionId}-${this.dataset.productId}`;
  let emailField = '';

  if (customerEmail) {
    emailField = `<input type="hidden" class="notify_email" name="contact[email]" value="${customerEmail}">`;
  } else {
    emailField = `
      <div class="field">
        <input required type="email" class="field__input notify_email" id="${emailId}" name="contact[email]"
          placeholder="${this.strings.email}" autocomplete="email">
        <label class="field__label visually-hidden" for="${emailId}">${this.strings.email}</label>
      </div>`;
  }

  this.inputsEl.innerHTML = `
    ${emailField}
    <input type="hidden" name="challenge" value="false">
    <input type="hidden" name="contact[body]" class="notify_form_message"
      data-body="${message}" value="${message}${variantTitle ? ' - ' + variantTitle : ''}">
    <button type="submit" class="button button--full-width">${this.strings.send}</button>
  `;

  const form = this.closest('form') || this.querySelector('form') || this.formEl;
  if (form) {
    form.addEventListener('submit', () => {
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const bodyInput = form.querySelector('input[name="contact[body]"]');
      if (emailInput && bodyInput) {
        const extra = ` | Email: ${emailInput.value || customerEmail || ''}`;
        if (!bodyInput.value.includes(' | Email:')) bodyInput.value += extra;
      }
    }, { once: true });
  }
}
  clearInputs() {
    if (this.inputsEl) this.inputsEl.innerHTML = '';
  }

  handleSuccessRedirect() {
    if (window.location.search.includes('contact_posted=true')) {
      if (this.formEl) this.formEl.querySelector('.product-notify-form__inputs')?.remove();
      if (this.messageEl) this.messageEl.textContent = this.strings.success;
      this.hidden = false;
    }
  }
}

if (!customElements.get('product-notify-form')) {
  customElements.define('product-notify-form', ProductNotifyForm);
}